/**
 * IntentPill — Design Primitive
 * Phase 9a.2 Step 3
 *
 * Authority: UI_DESIGN_CONTRACT_V3.md (Section A.1 — DESIGN Intent System)
 * PKG-024: Product Contract | PKG-009: UI Capabilities
 *
 * A pill/tag that renders using the intent system. Generic building block.
 * All colors resolve through DESIGN_INTENTS — zero inline hex codes.
 */

import React from 'react';
import { DESIGN_INTENTS } from '@/config/ui-invariants';
import { cn } from '@/lib/utils';

/**
 * IntentPill
 *
 * @param {string} intent - Key into DESIGN_INTENTS (primary, positive, negative, warning, info, neutral, muted)
 * @param {string} label - Display text for the pill
 * @param {string} [className] - Optional additional Tailwind classes
 */
export function IntentPill({ intent, label, className }) {
    const resolved = DESIGN_INTENTS[intent] || DESIGN_INTENTS.neutral;

    return (
        <span
            className={cn(
                'inline-flex items-center rounded-full px-3 py-1.5',
                'text-sm font-semibold border',
                resolved.bg,
                resolved.text,
                resolved.border,
                className
            )}
        >
            {label}
        </span>
    );
}

export default IntentPill;
